import { buildQueryParams } from '@/helpers/ApiHelper'
import type { IDiagnostic } from '@/models/Diagnostics/IDiagnostic'
import type { IRequestDiagnostic } from '@/models/Diagnostics/IRequestDiagnostic'
import type { ICpmBaseFilter } from '@/models/Filtering/ICpmBaseFilter'
import type { IResultsPage } from '@/models/Pagination/IResultsPage'
import { inject, injectable } from 'inversify'
import type IApiClient from '../IApiClient'
import { SERVICES_TYPES } from '../ServicesTypes'
import type IDiagnosticService from './IDiagnosticService'

@injectable()
export class DiagnosticService implements IDiagnosticService {
  private readonly apiClient: IApiClient
  private readonly diagnosticBaseUri: string = 'diagnostics'

  constructor(@inject(SERVICES_TYPES.ApiClient) apiClient: IApiClient) {
    this.apiClient = apiClient
  }

  async getDiagnostics(chargePointId: string, filters?: ICpmBaseFilter, abortController?: AbortController): Promise<IResultsPage<IDiagnostic>> {
    const queryParam = buildQueryParams({
      pageIndex: filters?.PageIndex,
      pageSize: filters?.PageSize,
      sortColumn: filters?.SortColumn,
      sortReversed: filters?.SortReversed
    })
    return this.apiClient.get<IResultsPage<IDiagnostic>>(`${this.diagnosticBaseUri}/${chargePointId}${queryParam}`, abortController)
  }

  async downloadDiagnostic(diagnosticId: string): Promise<{ blob: Blob; fileName?: string }> {
    return this.apiClient.getBlob(`${this.diagnosticBaseUri}/${diagnosticId}/download`)
  }

  async requestDiagnostic(chargePointId: string, requestDiagnostic: IRequestDiagnostic, abortController?: AbortController): Promise<string> {
    return this.apiClient.post<string>(`${this.diagnosticBaseUri}/${chargePointId}`, requestDiagnostic, abortController)
  }
}
